import React, { } from 'react';
import { Button, Sticker } from '@cordata/buffet';
import PropTypes from 'prop-types';

const BaseButton = ({
  icon,
  text,
  type,
  disabled,
  ...props
}) => (
  <Button
    className="ml-2"
    type={type}
    disabled={disabled}
    {...props}
  >
    <Sticker icon={icon} >
      <span className="d-none d-md-inline ml-2">{text}</span>
    </Sticker>
  </Button>
);

BaseButton.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['button', 'cancel', 'reset', 'submit']),
  disabled: PropTypes.bool,
};

BaseButton.defaultProps = {
  type: 'button',
  disabled: false,
};

export default BaseButton;
